export default "__VITE_ASSET__HKf4gDWm__"